import { debounce } from 'lodash';
import tippy from 'tippy.js/headless';

export default class BrixTabMenu {
  static init(...parameters) {
    return new BrixTabMenu(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.content = block.querySelector('.content');
    this.tabMenuWrapper = block.querySelector('.tab-menu-wrapper');
    this.tabMenu = block.querySelector('.tab-menu');

    this.tabMenuScrollWidth = this.tabMenu.scrollWidth;

    this.addButtonClickEvents('.tab-menu .menu-button');

    this.toggleDropdown();
    window.addEventListener('resize', debounce(() => {
      this.toggleDropdown(block);
    }), 300);
  }

  toggleDropdown() {
    const { offsetWidth } = this.tabMenuWrapper;

    if (offsetWidth <= this.tabMenuScrollWidth) {
      this.tabMenuWrapper.classList.add('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'true');

      if (!this.dropdownMenuWrapper) {
        this.addDropdownMenu();
      } else {
        this.dropdownMenuWrapper.classList.remove('-hidden');
      }
    } else {
      if (this.dropdownMenuWrapper) {
        this.dropdownMenuWrapper.classList.add('-hidden');
      }

      this.tabMenuWrapper.classList.remove('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'false');
    }
  }

  addDropdownMenu() {
    this.dropdownMenuWrapper = document.createElement('div');
    this.dropdownMenuWrapper.classList.add('dropdown-menu-wrapper');
    this.dropdownMenuToggle = document.createElement('button');
    this.dropdownMenuToggle.classList.add('dropdown-menu-toggle');
    this.dropdownMenu = this.tabMenu.cloneNode(true);
    this.dropdownMenu.classList.remove('tab-menu');
    this.dropdownMenu.classList.add('dropdown');

    this.currentPageLink = this.dropdownMenu.querySelector('.-current');
    if (this.currentPageLink) {
      this.currentPageLinkLabel = this.currentPageLink.querySelector('.label');
      this.dropdownMenuToggle.innerHTML = this.currentPageLinkLabel.innerHTML;
    }

    this.dropdownMenuWrapper.appendChild(this.dropdownMenuToggle);
    this.dropdownMenuWrapper.appendChild(this.dropdownMenu);
    this.tabMenuWrapper.after(this.dropdownMenuWrapper);

    this.addButtonClickEvents('.dropdown .menu-button', true);

    if (!this.tippyInstance) {
      this.setUpTippy();
    }
  }

  setUpTippy() {
    this.tippyInstance = tippy(this.dropdownMenuToggle, {
      content: this.dropdownMenu,
      offset: [0, 0],
      allowHTML: true,
      trigger: 'click',
      appendTo: this.dropdownMenuWrapper,
      interactive: 'true',
      placement: 'bottom-start',
      plugins: [{
        name: 'hideOnPopperBlur',
        defaultValue: true,
        fn(instance) {
          return {
            onCreate() {
              instance.popper.addEventListener('focusout', (event) => {
                if (
                  instance.props.hideOnPopperBlur
                      && event.relatedTarget
                      && !instance.popper.contains(event.relatedTarget)
                ) {
                  instance.hide();
                }
              });
            },
          };
        },
      }],
      popperOptions: {
        strategy: 'fixed',
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              padding: 0,
            },
          },
        ],
      },
      render(instance) {
        const popper = document.createElement('div');
        popper.appendChild(instance.props.content);
        return { popper };
      },
    });
  }

  addButtonClickEvents(buttonSelector, isDropdown = false) {
    if (this.block.classList.contains('-no-reload')) {
      const menuButtons = this.block.querySelectorAll(buttonSelector);
      [...menuButtons].forEach((menuButton) => {
        menuButton.addEventListener('click', (event) => {
          this.setCurrent(menuButtons, event.currentTarget.dataset, isDropdown);

          if (isDropdown) {
            this.tippyInstance.hide();
          }
        });

        if (window.location.hash === `#${menuButton.dataset.hash}`) {
          this.setCurrent(menuButtons, menuButton.dataset);
        }
      });
    }
  }

  setCurrent(menuButtons, dataset, isDropdown) {
    this.tabs = this.block.querySelectorAll('.tab');

    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }

    [...menuButtons].forEach((menuButton) => {
      if (menuButton.dataset.id === dataset.id) {
        menuButton.classList.add('-current');

        if (isDropdown) {
          const buttonLabel = menuButton.querySelector('.label');
          this.dropdownMenuToggle.innerHTML = buttonLabel.innerHTML;
        }
      } else {
        menuButton.classList.remove('-current');
      }
    });

    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-tab-menu', BrixTabMenu.init);
}
